import { render, staticRenderFns } from "./OtherIncome.vue?vue&type=template&id=489d3bde&scoped=true&"
import script from "./OtherIncome.vue?vue&type=script&lang=js&"
export * from "./OtherIncome.vue?vue&type=script&lang=js&"
import style0 from "./OtherIncome.vue?vue&type=style&index=0&id=489d3bde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d3bde",
  null
  
)

export default component.exports